import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import PropTypes from 'prop-types';
import GuestSelectorItem from '../../items/GuestSelectorItem';
import Box from '../../elements/Box';

function GuestsSelector({ value, dispatch, item, ...props }) {
  const dispatchWithField = (field) => (type) => {
    return dispatch({ field, type });
  };
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box className={className} style={style}>
      <GuestSelectorItem
        label={translate('cmp-guests-select-label-adults', 'Adults')}
        count={value.adults}
        dispatch={dispatchWithField('adults')}
        {...item}
      />
      <GuestSelectorItem
        label={translate('cmp-guests-select-label-children', 'Children')}
        count={value.children}
        dispatch={dispatchWithField('children')}
        {...item}
      />
      <GuestSelectorItem
        label={translate('cmp-guests-select-label-infants', 'Infants')}
        count={value.infants}
        dispatch={dispatchWithField('infants')}
        {...item}
      />
    </Box>
  );
}

GuestsSelector.propTypes = {
  /**
   * Value of the guest selector
   */
  value: PropTypes.objectOf(PropTypes.any),
  /**
   * Function for dispatching actions ({ type: 'INCREASE' | 'DECREASE', field: 'adults' | 'children' | 'adults' })
   */
  dispatch: PropTypes.func,
  /**
   * Css style applied to the component
   */
  style: PropTypes.objectOf(PropTypes.any),
  /**
   * Item settings
   */
  item: PropTypes.objectOf(PropTypes.any),
};

GuestsSelector.defaultProps = {
  value: {
    adults: 0,
    children: 0,
    infants: 0,
  },
  dispatch: () => {},
  style: {},
  item: {},
};

GuestsSelector.componentName = 'GuestsSelector';

export default GuestsSelector;
